import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FloatButton, message } from 'antd';
import { RootState } from '../../store/index';
import { ArrowLeftOutlined, UpOutlined, LinkOutlined, WeiboOutlined, QqOutlined, WechatOutlined, LinkedinOutlined } from '@ant-design/icons';
import { apiConfig, apiGetPage, apiGetDetail } from '../../request/api'
import { imageUrl, zeusApp } from '../../request/index';
import { useCustomData } from '../../pages/context/newsCustomDataProvider';


interface NewsDetailsProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
}

interface IconHoverStates {
    [key: string]: boolean;
}

interface PageData {
    id: string;
    newsImage: string;
    created_at: string;
    detail: string;
    title: string;
}

const NewsDetails: React.FC<NewsDetailsProps> = ({ handleViewChange, data }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [partList, setPartList] = useState<PageData | null>(null);
    const htmlElements = '';
    const languageCode = localStorage.getItem('siteLanguage') || 'zh';
    const [iconHoverStates, setIconHoverStates] = useState<IconHoverStates>({
        weibo: false,
        qq: false,
        wechat: false,
        linkedin: false,
        link: false,
    });
    const { getValue } = useCustomData();
    const back = getValue('back');
    const share = getValue('share');
    const ready = getValue('ready');


    useEffect(() => {
        apiGetDetail({
            tid: '3E0B92D9B5834E49B146D40BAE5814DF',
            id: data,
            languagecode: languageCode
        }).then((res) => {
            const rawData = res.data.data;
            let content = rawData.newsContent;

            // 利用正则替换img标签里的src为完整地址
            content = content.replace(/<img\s+src="([^"]+)"([^>]*)\/?>/g, (match: any, p1: any, p2: any) => {
                // p1 是图片ID
                const fullUrl = `${imageUrl}${p1}?zeus-app=${zeusApp}`;
                return `<img src="${fullUrl}"${p2} />`;
            });

            const updatedData: PageData = {
                id: rawData.id,
                newsImage: rawData.newsImage,
                created_at: rawData.onlineTime,
                detail: content,
                title: rawData.newstitle,
            };
            setPartList(updatedData);
        });
    }, [data]);

    const handleShareClick = () => {
        const url = window.location.href + '/';
        navigator.clipboard.writeText(url)
            .then(() => {
                // 可选：提示复制成功
                console.log('链接已复制到剪贴板：', url);
                message.success(ready)
            })
            .catch((err) => {
                console.error('复制失败:', err);
            });
    };

    const handleIconMouseOver = (iconName: string) => {
        setIconHoverStates({ ...iconHoverStates, [iconName]: true });
    };

    const handleIconMouseOut = (iconName: string) => {
        setIconHoverStates({ ...iconHoverStates, [iconName]: false });
    };

    // 根据悬停状态为图标设置样式
    const getIconStyle = (iconName: string) => {
        return iconHoverStates[iconName] ? { color: themeColor } : {};
    };
    const goback = () => {
        handleViewChange('news')
    }

    return (
        <div className='detail-content'>
            <div className='detail-back' style={{ color: themeColor, marginTop: '40px' }} onClick={goback}>
                <ArrowLeftOutlined />
                <div className='detail-back-right'> {back} </div>
            </div>
            {partList && <div className='detail-title'>{partList.title}</div>}
            {partList && <div className="detail-time">{partList.created_at}</div>}
            <div className="detail-share">
                <div>{share}</div>
                {/* <WeiboOutlined
                    className="iconFont"
                    onMouseOver={() => handleIconMouseOver('weibo')}
                    onMouseOut={() => handleIconMouseOut('weibo')}
                    onClick={handleShareClick}
                    style={getIconStyle('weibo')}
                />
                <QqOutlined
                    className="iconFont"
                    onMouseOver={() => handleIconMouseOver('qq')}
                    onMouseOut={() => handleIconMouseOut('qq')}
                    onClick={handleShareClick}
                    style={getIconStyle('qq')}
                />
                <WechatOutlined
                    className="iconFont"
                    onMouseOver={() => handleIconMouseOver('wechat')}
                    onMouseOut={() => handleIconMouseOut('wechat')}
                    onClick={handleShareClick}
                    style={getIconStyle('wechat')}
                />
                <LinkedinOutlined
                    className="iconFont"
                    onMouseOver={() => handleIconMouseOver('linkedin')}
                    onMouseOut={() => handleIconMouseOut('linkedin')}
                    onClick={handleShareClick}
                    style={getIconStyle('linkedin')}
                /> */}
                <LinkOutlined
                    className="iconFont"
                    onMouseOver={() => handleIconMouseOver('link')}
                    onMouseOut={() => handleIconMouseOut('link')}
                    onClick={handleShareClick}
                    style={getIconStyle('link')}
                />
            </div>
            <div className='newsdetails-content' dangerouslySetInnerHTML={{ __html: partList?.detail ?? '' }}>

            </div>
            <FloatButton.BackTop icon={<UpOutlined />} />
        </div>
    )

};

export default NewsDetails;
